module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABKUlEQVRIS+2UIUsEURSFz9kyIPgDTCaDgs2qSdD9CSJqkLkPhIkmq804Qd5dDCriT1gXTFptggaTyR+wIEyZIwsq4s46bpiy7Kv3cu653zvvEQ0eNqiNqXgl3QnFYmbLJHcBrElaADALoE/yBcCdpAt3fxyVuEosZjYDIAewJ+m+1WrdAHgi2Zc0GLBUluUmyVUA5wAyd3//PaRKnCGErqR5kjsxxodRzkIIK5IuSb7GGNsA9LN3SDxN0zbJawCL7v5W98jMbA7As6StTqfT/VPczA4BrLv7Rp3wV93MegBu3f1kbOchhH1JRyQPJJ2SPI4xng2ExnIOYIh5lmVJURRXAAbb9JIk2c7zvBib+aebxtLyja2RnP/3Iuv6JvRvqVu7rj7FUknoA3ZVnBgYpBLYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guangbi.png
// module id = ySZE
// module chunks = 410